import Advert from '@/classes/Advert.js'
export default class Campaign extends Advert {
    advert_type = 'campaigns'
    advert_type_capitalised = 'Campaigns'
    advert_type_singular = 'campaign'
    advert_type_singular_capitalised = 'Campaign'
}